import { render, staticRenderFns } from "./comment-ameliorer-laccessibilite-de-votre-site-web.vue?vue&type=template&id=56ce1a2c&"
import script from "./comment-ameliorer-laccessibilite-de-votre-site-web.vue?vue&type=script&lang=js&"
export * from "./comment-ameliorer-laccessibilite-de-votre-site-web.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports